import { useState, useEffect } from 'react';

/**
 * Detects if client side rendering using lifecycle event componentDidMount.
 *
 * @returns true if it is client side
 */

export default function useIsClientSide() {
  const [isClientSide, setIsClientSide] = useState(false);
  useEffect(() => {
    setIsClientSide(true);
  }, []);
  return isClientSide;
}
